import React, { useRef, useEffect } from 'react';

import validator from 'validator';
import { AttachmentUploadStatus } from '../../editor/types';
import Attachment from '../attachment';
import {
  addHttpInHrefOfAnchorTag,
  addTargetBlankToAnchorTag,
  findAndCleanAnchorTag,
} from '../../../components/sequence/shared/modals/email-modal/components/sidebar/tabs/utils/generate-email-preview';
import { convertNl2Br } from '../../functions/convert-nl-to-br';
import { sanitizeRichText } from '../../utils/sanitize-rich-text';

const EmailPreviewContent = ({ content, attachments }) => {
  const modifiedContent = sanitizeRichText(
    convertNl2Br(
      findAndCleanAnchorTag(
        addTargetBlankToAnchorTag(addHttpInHrefOfAnchorTag(content)),
      ),
    ),
  );

  const emailPreviewContent = useRef<HTMLDivElement>(null);

  let repliedEmailContent: Element = null;
  let isCollapsed = false;

  const onToggle = () => {
    if (isCollapsed) {
      repliedEmailContent.classList.remove('d-none');
      isCollapsed = false;
    } else {
      repliedEmailContent.classList.add('d-none');
      isCollapsed = true;
    }
  };

  const viewMoreContentBtn = document.createElement('button');
  const dotOne = document.createElement('span');
  const dotTwo = document.createElement('span');
  const dotThree = document.createElement('span');
  viewMoreContentBtn.appendChild(dotOne);
  viewMoreContentBtn.appendChild(dotTwo);
  viewMoreContentBtn.appendChild(dotThree);
  viewMoreContentBtn.onclick = onToggle;
  viewMoreContentBtn.classList.add('view-more-content-btn');

  useEffect(() => {
    if (emailPreviewContent?.current) {
      const links = emailPreviewContent.current.getElementsByTagName('a');

      Object.keys(links).forEach((key) => {
        const { href } = links[key];

        if (href && validator.isURL(href)) {
          try {
            const url = new URL(href);

            url.searchParams.set('preview', 'true');

            links[key].href = url;
          } catch (e) {
            // If href cannot be parsed as a URL, skip updating this link
          }
        }
      });

      const wrapperDiv = emailPreviewContent.current;

      const repliedEmailsClassNames = [
        'Saleshandy-quoted',
        'gmail_quote',
        'olQuotedText',
        'yahoo_quoted',
        'Apple-quoted',
      ];

      repliedEmailsClassNames.forEach((className) => {
        if (!repliedEmailContent) {
          repliedEmailContent = wrapperDiv.getElementsByClassName(
            className,
          )?.[0];
        }
      });

      if (repliedEmailContent) {
        repliedEmailContent.remove();
        wrapperDiv.appendChild(viewMoreContentBtn);
        wrapperDiv.appendChild(repliedEmailContent);
        repliedEmailContent.classList.add('d-none');
        isCollapsed = true;
      }
    }
  }, [emailPreviewContent]);

  return (
    <>
      <div
        ref={emailPreviewContent}
        className="email-preview-content"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: modifiedContent,
        }}
      />
      {attachments && attachments.length > 0 && (
        <div className="d-flex align-items-center mt-4 email-preview-attachments email-thread">
          {attachments?.map(({ id, name, size, type, preSignedUrl }, index) => (
            <Attachment
              key={`Attachment-${id || 'id'}-${index + 1}`}
              attachment={{
                attachmentId: id,
                file: {
                  name,
                  size,
                  type,
                },
                attachmentSize: Number(size),
                status: AttachmentUploadStatus.Existing,
                ...(preSignedUrl && { preSignedUrl }),
              }}
              showAttachmentDeleteButton={false}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default EmailPreviewContent;
